import { FieldErrors, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { BefehlFormAuftrag } from '../Generic'
import Auftrag31_14_15Form from './Auftrag31_14_15Form'
import Feld31_11_12Form from './Feld31_11_12Form'
import Feld31_13Form from './Feld31_13Form'
import Feld31_17Form from './Feld31_17Form'
import { Befehl31FormData } from './schema'
import { useMemo } from 'react'

export interface Auftrag31_10FormProps {
  readOnly: boolean
  'data-testid': string
  activateEmptyFieldWarnings?: boolean
  errors?: FieldErrors
}

export default function Auftrag31_10Form({
  readOnly,
  'data-testid': testId,
  errors,
  activateEmptyFieldWarnings = false
}: Readonly<Auftrag31_10FormProps>) {
  const { t } = useTranslation('ui-befehle')

  const formContext = useFormContext<Befehl31FormData>()
  const { formState } = formContext

  const fieldErrors = useMemo(() => {
    return errors ?? formState.errors
  }, [errors, formState.errors])

  return (
    <BefehlFormAuftrag
      auftragKennung="31.10"
      fieldName="auftrag_31_10.enabled"
      readOnly={true}
      disabled={false}
      testId={testId}
    >
      <div className="flex flex-col flex-wrap items-baseline w-full gap-1">
        <span data-testid={`${testId}-text-darf-im`}>
          {t('befehle.31.text.darf_im')}
        </span>

        <div className="w-full">
          <Feld31_11_12Form
            readOnly={readOnly}
            data-testid={`${testId}-feld-31-11-12`}
            errors={fieldErrors}
            activateEmptyFieldWarnings={activateEmptyFieldWarnings}
          />
        </div>
        <span data-testid={`${testId}-text-auf-einfahrgleis`}>
          {t('befehle.31.text.auf_einfahrgleis')}
        </span>
        <div className="w-full">
          <Feld31_13Form
            readOnly={readOnly}
            data-testid={`${testId}-feld-31-13`}
            errors={fieldErrors}
            activateEmptyFieldWarnings={activateEmptyFieldWarnings}
          />
        </div>
        <span data-testid={`${testId}-text-ueber`}>
          {t('befehle.31.text.ueber')}
        </span>

        <Auftrag31_14_15Form
          readOnly={readOnly}
          data-testid={`${testId}-auftrag-31-14-15`}
          activateEmptyFieldWarnings={activateEmptyFieldWarnings}
        />

        <div className="flex flex-wrap gap-2 items-baseline">
          <span data-testid={`${testId}-text-hinaus-bis`}>
            {t('befehle.31.text.hinaus_bis')}
          </span>

          <Feld31_17Form
            readOnly={readOnly}
            data-testid={`${testId}-feld-31-17`}
            errors={fieldErrors}
            activateEmptyFieldWarnings={activateEmptyFieldWarnings}
          />

          <span data-testid={`${testId}-text-rangieren`}>
            {t('befehle.31.text.rangieren')}
          </span>
        </div>
      </div>
    </BefehlFormAuftrag>
  )
}
